import { Table, TableBody, TableCell, TableRow, decodeHtml } from '../../../../Theme'

interface AttributeRowProps {
  label: string
  /** HTML, entity-encoded */
  value: string
}

function AttributeRow({ label, value }: AttributeRowProps) {
  return (
    <TableRow>
      <TableCell className="border text-text-color font-semibold leading-5">
        {label}
      </TableCell>
      <TableCell
        className="border text-text-color leading-5"
        dangerouslySetInnerHTML={{ __html: decodeHtml(value) }}
      />
    </TableRow>
  )
}

/** Technical specifications of a product: one row per attribute. */
export function SpecificationsTable({ attributes }: { attributes: Record<string, AttributeRowProps> }) {
  return (
    <Table className="table-auto border mb-8">
      <TableBody>
        {Object.entries(attributes).map(([key, attr]) => (
          <AttributeRow key={key} label={attr.label} value={attr.value} />
        ))}
      </TableBody>
    </Table>
  )
}
